const apiBase = 'https://predev.playermanager.club/api';

export const environment = {
  production: false,
  basePath: `${apiBase}`,
  MY_TOKEN: 'myToken',
  CLIENT_ID_KEYWORD: 'clientId',
  DOMAIN: `${apiBase}/api`,
  SERVER_API_PATH: `${apiBase}`,
};